/*hon el code sha8al men done el admin page
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/user/HomePage';
import LoginPage from './pages/user/LoginPage';
import SignupPage from './pages/user/SignupPage';
import AboutPage from './pages/user/AboutPage';
import ContactPage from './pages/user/ContactPage';
import RestaurantMenuPage from './pages/user/RestaurantMenuPage';
import CartPage from './pages/user/CartPage';
import CheckoutPage from './pages/user/CheckoutPage';
import RatingPage from './pages/user/RatingPage';
import OrderHistoryPage from './pages/user/OrderHistoryPage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [cart, setCart] = useState([]);
  const [user, setUser] = useState(null);
  
  // Login function
  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    setUser(userData);
  };

  // Logout function
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
  };

  // Add to cart function
  const addToCart = (item) => {
    const existingItem = cart.find(cartItem => cartItem.id === item.id);
    
    if (existingItem) {
      setCart(cart.map(cartItem => 
        cartItem.id === item.id 
          ? { ...cartItem, quantity: cartItem.quantity + 1 } 
          : cartItem
      ));
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
    }
  };

  // Update cart item quantity
  const updateQuantity = (itemId, newQuantity) => {
    if (newQuantity <= 0) {
      setCart(cart.filter(item => item.id !== itemId));
    } else {
      setCart(cart.map(item => 
        item.id === itemId ? { ...item, quantity: newQuantity } : item
      ));
    }
  };

  // Remove item from cart
  const removeFromCart = (itemId) => {
    setCart(cart.filter(item => item.id !== itemId));
  };

  // Clear cart after checkout
  const clearCart = () => {
    setCart([]);
  };

  return (
    <Router>
      <div className="app">
        <Navbar isLoggedIn={isLoggedIn} onLogout={handleLogout} cartItemCount={cart.reduce((total, item) => total + item.quantity, 0)} />
        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
            <Route path="/signup" element={<SignupPage onSignup={handleLogin} />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/restaurant/:id" element={
              <RestaurantMenuPage 
                addToCart={addToCart} 
                isLoggedIn={isLoggedIn} 
              />
            } />
            <Route path="/cart" element={
              isLoggedIn ? 
                <CartPage 
                  cart={cart} 
                  updateQuantity={updateQuantity} 
                  removeFromCart={removeFromCart} 
                /> : 
                <Navigate to="/login" />
            } />
            <Route path="/checkout" element={
              isLoggedIn ? 
                <CheckoutPage 
                  cart={cart} 
                  clearCart={clearCart} 
                  user={user} 
                /> : 
                <Navigate to="/login" />
            } />
            <Route path="/rate/:orderId" element={
              isLoggedIn ? 
                <RatingPage user={user} /> : 
                <Navigate to="/login" />
            } />
            <Route path="/order-history" element={
              isLoggedIn ? 
                <OrderHistoryPage user={user} /> : 
                <Navigate to="/login" />
            } />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;*/




import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Components (génériques)
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Admin layout
//import AdminLayout from './components/AdminLayout';
import AdminLayout from './pages/admin/AdminLayout';
// Pages utilisateur
import HomePage from './pages/user/HomePage';
import LoginPage from './pages/user/LoginPage';
import SignupPage from './pages/user/SignupPage';
import AboutPage from './pages/user/AboutPage';
import ContactPage from './pages/user/ContactPage';
import RestaurantMenuPage from './pages/user/RestaurantMenuPage';
import CartPage from './pages/user/CartPage';
import CheckoutPage from './pages/user/CheckoutPage';
import RatingPage from './pages/user/RatingPage';
import OrderHistoryPage from './pages/user/OrderHistoryPage';

// Pages admin
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/DashboardHome';
import ManageUsers from './pages/admin/ManageUsers';
import ManageRestaurants from './pages/admin/ManageRestaurants';
import ManageFoodItems from './pages/admin/ManageFoodItems';
import OrdersManagement from './pages/admin/OrdersManagement';
import Statistics from './pages/admin/StatisticsPage';
import ContactMessages from './pages/admin/ContactMessagesPage';

// Authentification admin
import { AuthProvider } from './pages/admin/AuthContext';
import ProtectedRoute from './pages/admin/ProtectedRoute';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [cart, setCart] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);
  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
  };

  const addToCart = (item) => {
    const exists = cart.find(c => c.id === item.id);
    if (exists) {
      setCart(cart.map(c => c.id === item.id ? { ...c, quantity: c.quantity + 1 } : c));
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
    }
  };

  const updateQuantity = (itemId, qty) => {
    setCart(qty <= 0
      ? cart.filter(item => item.id !== itemId)
      : cart.map(item => item.id === itemId ? { ...item, quantity: qty } : item)
    );
  };

  const removeFromCart = (id) => {
    setCart(cart.filter(i => i.id !== id));
  };

  const clearCart = () => setCart([]);

  const renderUserLayout = (PageComponent, props = {}) => (
    <div className="app">
      <Navbar isLoggedIn={isLoggedIn} onLogout={handleLogout} cartItemCount={cart.reduce((t, i) => t + i.quantity, 0)} />
      <main className="main-content">
        <PageComponent {...props} />
      </main>
      <Footer />
    </div>
  );

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute>
              <AdminLayout>
                <ManageUsers />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/restaurants" element={
            <ProtectedRoute>
              <AdminLayout>
                <ManageRestaurants />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/food-items" element={
            <ProtectedRoute>
              <AdminLayout>
                <ManageFoodItems />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/orders" element={
            <ProtectedRoute>
              <AdminLayout>
                <OrdersManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/statistics" element={
            <ProtectedRoute>
              <AdminLayout>
                <Statistics />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/messages" element={
            <ProtectedRoute>
              <AdminLayout>
                <ContactMessages />
              </AdminLayout>
            </ProtectedRoute>
          } />

          {/* User Routes */}
          <Route path="/" element={renderUserLayout(HomePage)} />
          <Route path="/login" element={renderUserLayout(LoginPage, { onLogin: handleLogin })} />
          <Route path="/signup" element={renderUserLayout(SignupPage, { onSignup: handleLogin })} />
          <Route path="/about" element={renderUserLayout(AboutPage)} />
          <Route path="/contact" element={renderUserLayout(ContactPage)} />
          <Route path="/restaurant/:restaurantId" element={renderUserLayout(RestaurantMenuPage, { addToCart, isLoggedIn })} />

          <Route path="/cart" element={
            isLoggedIn ? renderUserLayout(CartPage, { cart, updateQuantity, removeFromCart }) : <Navigate to="/login" />
          } />
          <Route path="/checkout" element={
            isLoggedIn ? renderUserLayout(CheckoutPage, { cart, clearCart, user }) : <Navigate to="/login" />
          } />
          <Route path="/rate/:orderId" element={
            isLoggedIn ? renderUserLayout(RatingPage, { user }) : <Navigate to="/login" />
          } />
          <Route path="/order-history" element={
            isLoggedIn ? renderUserLayout(OrderHistoryPage, { user }) : <Navigate to="/login" />
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
